import { useMutation, useQueryClient } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useUpdateUser = () => {
  const queryClient = useQueryClient();
  const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  return useMutation({
    mutationFn: async (input) => {
      const result = await restClient({ 
        url: `${prefix}/profile`, 
        method: 'put',
        data: input
      });
      return result;
    },
    onSuccess: async () => {
      // Invalidate and refetch user data only
       await queryClient.invalidateQueries(['userData']);
    }
  });
};
